import { render, staticRenderFns } from "./MultiComplete.vue?vue&type=template&id=dbf1a4d4&scoped=true&"
import script from "./MultiComplete.vue?vue&type=script&lang=ts&"
export * from "./MultiComplete.vue?vue&type=script&lang=ts&"
import style0 from "./MultiComplete.vue?vue&type=style&index=0&id=dbf1a4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf1a4d4",
  null
  
)

export default component.exports